import { render, staticRenderFns } from "./ClientMapForm.vue?vue&type=template&id=c2f85c16&scoped=true&"
import script from "./ClientMapForm.vue?vue&type=script&lang=js&"
export * from "./ClientMapForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f85c16",
  null
  
)

export default component.exports